import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import AttnLogo from './attn-logo'
import MenuIcon from './menu-icon'

class Nav extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }

    this.handleMenuClick = this.handleMenuClick.bind(this)
  }

  handleMenuClick () {
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen
    }))
  }

  render () {
    const { theme } = this.props
    const { menuOpen } = this.state

    const navClasses = menuOpen ? 'nav-new is-open' : 'nav-new'

    return (
      <nav
        className={theme === 'dark' ? `${navClasses} nav--dark` : navClasses}
      >
        <Link to='/' className={`header__link`}>
          <AttnLogo classes='logo' theme={theme} menuOpen={menuOpen} />
        </Link>
        <button className='menu' onClick={this.handleMenuClick}>
          <MenuIcon menuOpen={menuOpen} />
        </button>
        <div className='nav__links'>
          <ul className='nav__links-wrapper'>
            <li><Link to='/originals'>Originals</Link></li>
            <li><Link to='/creativeshop'>Creative shop</Link></li>
            <li><Link to='/madeyoulook'>Made You Look</Link></li>
            <li><Link to='/press'>Press</Link></li>
            <li><Link to='/careers'>Careers</Link></li>
            <li><Link to='/contact'>Contact</Link></li>
          </ul>
        </div>
      </nav>
    )
  }
}

Nav.propTypes = {
  theme: PropTypes.string
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/nav-new.js